<template>
  <div class="mobile-crumb">
    <CIcon
      name="chevron_left"
      class="icon-back"
    />
    <NuxtLink
      v-if="closestParent"
      class="label"
      :to="route(closestParent.slug)"
    >
      {{ closestParent.name }}
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import CIcon from '../../../atoms/CIcon'
import { ClosestParentBreadcrumbProps } from './ClosestParentBreadcrumb.props'

const props = withDefaults(defineProps<ClosestParentBreadcrumbProps>(), {
  breadcrumb: () => ({
    name: undefined,
    parents: [],
  }),
  basePath: '',
  showStart: true,
  hasFiltersInQuery: true,
})

const route = (parentSlug?: string) => {
  const route = useRoute()
  if (!parentSlug) return { path: '/' }
  return {
    path: `${props.basePath}${parentSlug}`,
    query: props.hasFiltersInQuery ? route.query : undefined,
  }
}

const parentCrumbs = computed(() =>
  props.showStart
    ? [{ name: 'Start' }, ...(props.breadcrumb.parents as BreadcrumbParent[])]
    : props.breadcrumb.parents,
)

const closestParent = computed(() => parentCrumbs.value?.slice(-1).pop())
</script>

<script lang="ts">
import { defineComponent } from 'vue'
import { BreadcrumbParent } from '../CBreadcrumbs.props'

export default defineComponent({
  name: 'ClosestParentBreadcrumb',
})
</script>
